<div class="overlay" *ngIf="revertingErrorState"></div>
<div *ngIf="selectedTool !== TOOL.DRAWING" class="overlay invisible" #invisibleOverlay></div>
<span id="cursor-dot" [ngClass]="selectedMapTypeTheme"></span>

<div *ngIf="!isDrawingThroughFV;else extendedGeofenceDrawingTools" class="drawing-controls">
  <button id="undo" class="action-undo" title="Undo" i18n-title (click)="undo()" [disabled]="!enableDrawingControls"><svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.207 6.993L6.354 9.14l-.707.707-3.354-3.354L5.647 3.14l.707.707-2.147 2.146H12.5a4.5 4.5 0 1 1 0 9H4v-1h8.5a3.5 3.5 0 1 0 0-7H4.207z" fill="#757575"/></svg></button>
  <button id="redo" class="action-redo" title="Redo" i18n-title (click)="redo()" [disabled]="!enableDrawingControls"><svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.793 6.994l-2.147 2.147.707.707 3.354-3.354-3.354-3.353-.707.707 2.147 2.146H6.5a4.5 4.5 0 0 0 0 9H15v-1H6.5a3.5 3.5 0 1 1 0-7h8.293z" fill="#757575"/></svg></button>
  <button id="cancel" class="action-cancel" title="Cancel" i18n-title (click)="cancel()"><svg   width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.793 11.5L7.257 7.964l.707-.707 3.536 3.536 3.536-3.536.707.707-3.536 3.536 3.536 3.536-.707.707-3.536-3.536-3.536 3.536-.707-.707 3.536-3.536zM11.5 2a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm0 1a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17z" fill="#757575" fill-rule="evenodd"/></svg></button>
</div>

<div class="fence-error" *ngIf="!isDrawingThroughFV && (revertingErrorState || nonRevertingErrorState)">
  {{getErrorsInDrawing()}}
</div>

<div #geofencePopup phx-tooltip [phxContent]="geofenceTooltipText" class="fence-popup"></div>

<ng-template #extendedGeofenceDrawingTools>
  <div class="geofence-drawing-controls-ext">
    <div class="btn-group d-flex align-items-center elevation-strong-2 mr-12">
      <div phx-tooltip phxContent="Polygon" i18n-phxContent>
        <button
          id="draw-square"
          [class.selected]="selectedTool === TOOL.POLYGON"
          [disabled]="revertingErrorState"
          (click)="selectTool(TOOL.POLYGON)"
        >
          <svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.913a1.5 1.5 0 1 1 1.915-1.915h9.17A1.5 1.5 0 1 1 16 5.913v9.17a1.5 1.5 0 1 1-1.915 1.915h-9.17A1.5 1.5 0 1 1 3 15.083v-9.17zm.5-1.915a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM4 5.913v9.17c.426.151.764.489.915.915h9.17c.151-.426.489-.764.915-.915v-9.17a1.504 1.504 0 0 1-.915-.915h-9.17c-.151.426-.489.764-.915.915zm-.5 10.085a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm11.5.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm.5-11.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" fill="#757575"/></svg>
        </button>
      </div>
      <div>
        <div [hidden]="selectedTool !== TOOL.CIRCLE" class="tool-extras">
          <nz-form-label nzFor="circle-radius" [nzNoColon]="true" i18n>Radius</nz-form-label>
          <nz-input-group
            class="affix-input-group"
            [nzAddOnAfter]="radiusSuffix"
          >
          <input #circleRadiusInput nz-input name="circle-radius" type="text" autocomplete="off"
            [class.input-error]="hasCircleRadiusInputError"
            [ngModel]="formRadius || ''" (ngModelChange)="onUpdateFormRadius($event, circleRadiusInput)"/>
          </nz-input-group>
          <ng-template #radiusSuffix>{{ metricUnit }}</ng-template>
          <div class="popover-arrow-top-cover"></div>
          <div class="popover-arrow"></div>
        </div>
        <div class="btn-tool" phx-tooltip phxContent="Circle" i18n-phxContent>
          <button
            id="draw-circle"
            [class.selected]="selectedTool === TOOL.CIRCLE"
            [disabled]="revertingErrorState"
            (click)="selectTool(TOOL.CIRCLE)"
          >
            <svg   width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.359 11.955a7.508 7.508 0 0 1-5.903 5.904 1.5 1.5 0 0 1-2.913 0 7.508 7.508 0 0 1-5.902-5.904 1.5 1.5 0 0 1 0-2.914 7.508 7.508 0 0 1 5.901-5.9 1.5 1.5 0 0 1 2.915 0 7.508 7.508 0 0 1 5.901 5.9 1.5 1.5 0 0 1 .001 2.914zM8.644 4.142a1.5 1.5 0 0 0 2.711 0 6.508 6.508 0 0 1 5.003 5 1.5 1.5 0 0 0 0 2.713 6.508 6.508 0 0 1-5.001 5.003 1.5 1.5 0 0 0-2.714 0 6.508 6.508 0 0 1-5.002-5.004 1.5 1.5 0 0 0 .001-2.712 6.508 6.508 0 0 1 5.002-5zm1.856-.644a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zm0 14a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zm7-7a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zm-14 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z" fill="#0058C8"/></svg>
          </button>
        </div>
      </div>
      <div phx-tooltip phxContent="Drawing" i18n-phxContent>
        <button
          id="draw-polygon"
          [disabled]="revertingErrorState"
          (click)="selectTool(TOOL.DRAWING)"
          [class.selected]="selectedTool === TOOL.DRAWING"
        >
          <svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 4.998a1.5 1.5 0 1 0-1.354-.853l-5 5a1.5 1.5 0 1 0 0 2.708l5 4.998a1.5 1.5 0 1 0 2.708 0l5-5a1.5 1.5 0 1 0-.707-.707l-5 5a1.494 1.494 0 0 0-1.294 0l-5-5a1.494 1.494 0 0 0 0-1.293l5-5c.196.095.415.147.647.147zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm-7 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm7 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm7-7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" fill="#757575"/></svg>
        </button>
      </div>      
    </div>
    <div class="btn-group drawing-actions d-flex align-items-center elevation-strong-2">
      <div phx-tooltip phxContent="Undo" i18n-phxContent>
        <button
          id="undo"
          class="action-undo"
          (click)="undo()"
          [disabled]="shouldDisableUndoAndReset"
        >
          <svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.207 6.993L6.354 9.14l-.707.707-3.354-3.354L5.647 3.14l.707.707-2.147 2.146H12.5a4.5 4.5 0 1 1 0 9H4v-1h8.5a3.5 3.5 0 1 0 0-7H4.207z" fill="#757575"/></svg>
        </button>
      </div>
      <div phx-tooltip phxContent="Redo" i18n-phxContent >
        <button
          id="redo"
          class="action-redo"
          (click)="redo()"
          [disabled]="shouldDisableRedo"
        >
          <svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.793 6.994l-2.147 2.147.707.707 3.354-3.354-3.354-3.353-.707.707 2.147 2.146H6.5a4.5 4.5 0 0 0 0 9H15v-1H6.5a3.5 3.5 0 1 1 0-7h8.293z" fill="#757575"/></svg>
        </button>
      </div>
      <div phx-tooltip [phxContent]="cancelButtonText">
        <button
          id="cancel"
          class="action-cancel semi-bold-14"
          (click)="cancel()"
          [disabled]="shouldDisableUndoAndReset"
          >
            {{cancelButtonText}}
        </button>
      </div>
    </div>
  </div>
</ng-template>
